import React, { useState, useEffect } from 'react';
import { useAuth } from './auth';
import CardWrapper from './CardWrapper'; 
import { getBackendURL } from './utils';


 function NotificationsSettings() {
  const { user, accessToken } = useAuth();
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState(user?.settings || null);

  useEffect(() => {
    const initializeSettings = async () => {
      if (!settings && user) {
        setLoading(true);

        if (user && !user.id) {
            return;
        }
        
        console.log("user:  ", user);
        try {
          const res = await fetch(getBackendURL() + '/user_settings/?user_id='+user.id, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${accessToken}`,
            },
            body: JSON.stringify({
              user_id: user.user_id,
              sms_opt_in: false,
              email_opt_in: false,
              push_opt_in: false,
            }),
          });

          if (res.ok) {
            const newSettings = await res.json();
            setSettings(newSettings);
          }
        } catch (err) {
          console.error('Error initializing user settings:', err);
        } finally {
          setLoading(false);
        }
      }
    };

    initializeSettings();
  }, [settings, user, accessToken]);

  const handleToggleSmsOptIn = async (checked) => {
    if (!settings) return;

    try {
      const res = await fetch(getBackendURL() + `/user_settings/${settings.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ sms_opt_in: checked }),
      });

      if (res.ok) {
        const updatedSettings = await res.json();
        setSettings(updatedSettings);
      }
    } catch (err) {
      console.error('Error updating SMS opt-in setting:', err);
    }
  };

  if (!user) {
    return (
      <CardWrapper>
        <h2>Notification Settings</h2>
        <p>This page is only available for logged-in users. Below are the settings you can manage if you have an account:</p>
        <div>
          <label>
            <input type="checkbox" disabled />
            Receive SMS notifications (requires login)
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox" disabled />
            Receive email notifications (requires login)
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox" disabled />
            Receive push notifications (requires login)
          </label>
        </div>
      </CardWrapper>
    );
  }

  if (loading || !settings) {
    return <CardWrapper>
        <h1>Your user settings are not ready yet. 
        Trying to initialize now...
        </h1>
        <p>Please contact the developer at 
            info@heldsolutionsllc.net 
            or on Instagram at @thepersonaltrainersclub 
            if there are any issues.
        </p>
        <p>Loading...</p></CardWrapper>;
  }

  return (
    <CardWrapper>
      <h2>Notification Settings</h2>
      <div>
        <label>
          <input
            type="checkbox"
            checked={settings.sms_opt_in}
            onChange={(e) => handleToggleSmsOptIn(e.target.checked)}
          />
          Receive SMS notifications
        </label>
      </div>
      <div>
        <label>
          <input type="checkbox" disabled />
          Receive email notifications (disabled)
        </label>
      </div>
      <div>
        <label>
          <input type="checkbox" disabled />
          Receive push notifications (disabled)
        </label>
      </div>
    </CardWrapper>
  );
}

export default NotificationsSettings;